import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  isHidden?: boolean;
};

const ExperimentalFeatureBanner: React.FC<Props> = ({ isHidden = false }) => {
  const { t } = useTranslation();

  if (isHidden) return null;

  return (
    <Box sx={{ my: 2 }}>
      <Alert severity="warning">{t('global.experimentalFeatureAlert')}</Alert>
    </Box>
  );
};

export default ExperimentalFeatureBanner;
